module.exports = __webpack_public_path__ + "static/media/full-screen.5f6ecba2.svg";